import React from "react";
import { useState } from 'react';
import { styled } from "@mui/system";
import { Box, Typography, Dialog } from '@mui/material';
import { useNavigate } from "react-router-dom";
import BackgroundContainer from '../components/BackgroundContainer';
import BaseHeader from '../components/BaseHeader';
import BaseButton from '../components/BaseButton';
import BaseFormContainer from "../components/BaseFormContainer";
import TermsOfUseContent from '../components/TermsOfUseContent';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent';
import InstallGuide from "../components/InstallGuide";


const ScrollableContent = styled(Box)(({ theme }) => ({
    overflowY: "auto",
    paddingRight: theme.spacing(1),

    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(255, 191, 229, 0.4)',
        borderRadius: '8px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
    },
}));

const StyledRule = styled(Typography)(({ theme }) => ({
    fontFamily: 'Playfair Display, serif',
    fontSize: '1.2rem',
    color: '#c2b8c2',
    lineHeight: 1.5,
    marginBottom: theme.spacing(2.5),
    textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
    paddingBottom: theme.spacing(1),
    '@media (max-width: 400px)': {
        fontSize: '1.1rem',
    },
    '@media (max-width: 360px)': {
        fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
        fontSize: '0.95rem',
    },
}));

const FAQ = () => {
    const navigate = useNavigate();
    const [showLegalPage, setShowLegalPage] = useState(null) // 'terms' or 'privacy' or null
    const [guideKey, setGuideKey] = useState(0);

    const refreshGuide = () => {
        localStorage.removeItem('installGuideShown');
        setGuideKey(prev => prev + 1);
    };

    const rules = [
        <StyledRule>
            Can i download the app? <br />
            <Box component="span" sx={{ color: '#ffbfe5', cursor: 'pointer' }} onClick={() => refreshGuide()}>
                Click To See How
            </Box>
        </StyledRule>,
        <StyledRule>
            How Many Cards Are There? <br /> Currenty more than 400!
        </StyledRule>,
        <StyledRule>
            Do You Have A Card Version Of The Game? <br /> Not currently, we have alot of demand for it, but its hard to pick so few question out of the bunch we have!
        </StyledRule>,
        <StyledRule>
            Where Can I Contact You? <br /> For any question, collaboration, or any matter, you can always contact us on deeper@deepergm.com
        </StyledRule>,
        <StyledRule sx={{ fontSize: '0.9rem', color: '#c2b8c2' }}>
            Here you can go through the{' '}
            <Box component="span" sx={{ color: '#ffbfe5', cursor: 'pointer' }} onClick={() => setShowLegalPage('terms')}>
                Terms of Use
            </Box>{' '}
            and{' '}
            <Box component="span" sx={{ color: '#ffbfe5', cursor: 'pointer' }} onClick={() => setShowLegalPage('privacy')}>
                Privacy Policy
            </Box>
        </StyledRule>
    ];

    return (
        <BackgroundContainer>
            <BaseFormContainer sx={{ width: '80%', flex: 1, maxHeight: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <BaseHeader sx={{
                    fontSize: '3rem',
                    '@media (max-width: 363px)': {
                        fontSize: '2.5rem', // 🔒 Last-resort fallback for smallest devices
                    }, paddingTop: '10px', textAlign: 'center', filter: 'drop-shadow(0 0 3px rgba(177, 39, 135, 0.36))',
                }}>
                    FAQ
                </BaseHeader>
                <ScrollableContent>
                    {rules.map((rule, index) => (
                        <Box key={index} sx={{ borderBottom: '1px solid rgba(255, 191, 229, 0.1)', display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '1rem' }}>
                            <StyledRule key={index}>
                                {index + 1}.
                            </StyledRule>
                            <Box>
                                {rule}
                            </Box>
                        </Box>
                    ))}
                </ScrollableContent>
                <Dialog
                    open={!!showLegalPage}
                    onClose={() => setShowLegalPage(null)}
                    fullScreen
                    PaperProps={{
                        style: {
                            background: '#0C0717',
                            padding: '20px',
                            color: '#fff',
                        }
                    }}
                >
                    <Box sx={{ overflowY: 'auto', maxHeight: '80vh', padding: '10px' }}>
                        {showLegalPage === 'terms' ? <TermsOfUseContent /> : <PrivacyPolicyContent />}
                    </Box>

                    <BaseButton onClick={() => setShowLegalPage(null)} sx={{
                        width: '100%',
                        marginTop: '10px',
                        marginBottom: '20px',
                        alignSelf: 'center',
                        fontSize: '1.1rem',
                        '@media (max-width: 360px)': {
                            fontSize: '1rem',
                            minWidth: '80%',
                        },
                        '@media (max-width: 320px)': {
                            fontSize: '0.95rem',
                            minWidth: '85%',
                        },

                    }}>
                        Back
                    </BaseButton>
                </Dialog>
                <InstallGuide triggerRefresh={guideKey} />
                <BaseButton sx={{ marginTop: 3, alignSelf: 'center' }} onClick={() => navigate(-1)}>Back</BaseButton>
            </BaseFormContainer>
        </BackgroundContainer>
    );
};

export default FAQ;
